import { Grid, TextField, Box, Typography } from "@mui/material";
import usePersonStore from "../../../../store/personStore";
import { useEffect, useState } from "react";
export type searchCustomFieldProps = {
    onChange: (searchParam: string) => void;
    customFieldId: string | null;
}

export default function SelectTriageCustomField({ onChange, customFieldId }: searchCustomFieldProps) {
    const defaultLocation = usePersonStore(state => state.company.defaultLocation)
    const [customfieldLabel, setCustomFieldLabel] = useState<string | null>()
    useEffect(() => {
        if (defaultLocation?.customFields) {
            const myLabel = defaultLocation!.customFields.find((customField) => customField.id === customFieldId)
            setCustomFieldLabel(myLabel?.name)
        }
    }, [customFieldId])
    return (
        <Grid size={12} textAlign="center"
            style={{ maxWidth: "275px" }}>
            <Typography>Enter the {customfieldLabel} you would like to search by</Typography>
            <Box sx={{ paddingTop: ".5rem" }}>
                <TextField name="searchParam"
                    fullWidth
                    label="Enter your search criteria"
                    onChange={(choice) => {
                        onChange(choice.target.value)
                    }}
                >
                </TextField>
            </Box>
        </Grid>
    )
}